<template>
  <div id="JtDashboard">
    <div class="dashboard-bar">
      <h1 id="title" v-if="title">
        {{ title }}
      </h1>
    </div>
    <div id="dashboard">
      <slot />
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'JtDashboard',
  props: {
    title: {
      type: String,
      required: false
    },
    shouldShowReloadDashboardButton: {
      type: Boolean,
      required: false,
      default: true
    }
  }
})
export default class JtDashboard extends Vue {

}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

#JtDashboard {
  padding: 15px;

  .dashboard-bar {
    display: flex;
    justify-content: space-between;

    h1 {
      margin: 0px;
      font-size: 2rem;
      font-weight: 400;
      line-height: 2rem;
      margin-top: 10px;
      margin-bottom: 30px;
      width: auto;
    }
  }

  #dashboard {
    display: grid;
    grid-template-columns: repeat(12, calc(((100% - (20px * 11)) / 12)));
    grid-auto-rows: 85px;
    grid-gap: 25px 20px;

    .card {
      padding: 12px;
      background: white;
      overflow: auto;
    }
  }
}
</style>
